// extracted by mini-css-extract-plugin
export default {"header":"viewer_header__pEkgr","header__text":"viewer_header__text__n9nDz","header__addButtonText":"viewer_header__addButtonText__Hv2hQ"};